import { z } from 'zod';

import { IEndpointSchema, makeEndpoint } from '../common';

export const MembershipCurrenciesOfUserQueryRequestSchema = z.object({
  organizationId: z.string().uuid().optional(),
});

export const GetMembershipCurrenciesOfUserEndpoint = makeEndpoint({
  method: 'GET',
  url: () => `v1/users/me/currencies`,
  requestSchema: MembershipCurrenciesOfUserQueryRequestSchema,
  responseSchema: z.array(z.string()),
});

export type IGetMembershipCurrenciesOfUserEndpoint = IEndpointSchema<typeof GetMembershipCurrenciesOfUserEndpoint>;
